import { AccountTypeEnum } from 'api-hooks/transactions/transfer';
import HOCInput from 'components/common/hoc-input';
import { Input } from 'components/elements';
import Text from 'components/elements/text';
import {
  FullContainer,
  HalfContainer,
  SeparatorVertical,
} from 'components/styles';
import BankAccountSelectInput from 'legacy-modules/master/bank-account/components/select-input';
import CashAccountSelectInput from 'legacy-modules/master/cash-account/components/select-input';
import { CardSection } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';

export function ReceiverFormCard() {
  const { t } = useTranslation();

  return (
    <HalfContainer>
      <CardSection>
        <Text variant="HeadingXSmall">{t('common:to')}</Text>
        <SeparatorVertical $margin={16} />
        <FullContainer>
          <Input
            type="select"
            name="toAccountType"
            label={t('common:type')}
            placeholder={t('common:type')}
            options={[
              {
                id: AccountTypeEnum.bank,
                label: t(`common:${AccountTypeEnum.bank}`),
              },
              {
                id: AccountTypeEnum.cash,
                label: t(`common:${AccountTypeEnum.cash}`),
              },
            ]}
            required
            hideRequiredStar
          />
        </FullContainer>
        <FullContainer>
          <HOCInput keys={['toAccountType']}>
            {(values) => {
              switch (values.toAccountType) {
                case AccountTypeEnum.bank:
                  return (
                    <BankAccountSelectInput name="toAccountable" required />
                  );
                case AccountTypeEnum.cash:
                  return (
                    <CashAccountSelectInput name="toAccountable" required />
                  );
              }
            }}
          </HOCInput>
        </FullContainer>
      </CardSection>
    </HalfContainer>
  );
}
